import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H5 } from 'foundations-components/transitional/components/H5';
import SelectEmbedStyleV2 from 'MeetingsAdmin/components/embed/SelectEmbedStyleV2';
import { getDefaultMeetingName } from 'meetings-utils/meetingName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CopyEmbedScriptDialogV2({
  link,
  sendEmbedCodeEmail,
  onClose
}) {
  const onSendEmbedCodeEmail = useCallback((emailAddress, linkId) => {
    sendEmbedCodeEmail(emailAddress, linkId);
  }, [sendEmbedCodeEmail]);
  const linkName = useMemo(() => link.name || getDefaultMeetingName(link.customParams.durations, true), [link.customParams.durations, link.name]);
  return /*#__PURE__*/_jsxs(Modal, {
    width: 540,
    "data-selenium-test": "embed-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose,
        "data-selenium-test": "embed-modal-close"
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedModal.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(H5, {
        marginBlockEnd: "100",
        children: linkName
      }), /*#__PURE__*/_jsx("p", {
        "data-selenium-test": "embed-modal-link",
        children: link.link
      }), /*#__PURE__*/_jsx(SelectEmbedStyleV2, {
        link: link,
        onSendEmbedCodeEmail: onSendEmbedCodeEmail
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      paddingBlockStart: "0",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editLink.confirmCreate"
        })
      })
    })]
  });
}
export default CopyEmbedScriptDialogV2;